import {BinaryContent} from 'rlink-repos/content';
export class ContentRegistry {
  constructor (contentClasses) {
    this._registry = new Map();
    this.registerClasses(contentClasses);
    this.implicitlyRegister('BinaryContent', BinaryContent);

  }
  loadClassNamed (name) {
    if (!this._registry.has(name)) {
      throw new Error(`Unregistered class name: ${name}`);
    }
    return this._registry.get(name);
  }

  hasClassNamed (name) {
    return this._registry.has(name);
  }

  get classes () {
    let obj = {};
    for (let [name, klass] of this._registry) {
      obj[name] = klass;
    }
    return obj;
  }
  registerClass (name, contentClass, force=false) {
    if (!name) {
      throw new Error(`Must provide a name to register ${contentClass}`);
    }
    let existing = this._registry.get(name);
    if (!force && existing && existing !== contentClass) {
      throw new Error(`Content class already registered under the name ${name}!\nAttempting to register: ${contentClass}\nExisting class: ${existing}`);
    }
    if (!contentClass || !('_setRegisteredName' in contentClass) ) {
      throw new Error(`Cannot register content class named ${name} - invalid contentClass:  ${contentClass}`);
    }
    contentClass._setRegisteredName(name);
    this._registry.set(name, contentClass);
  }

  registerClasses (contentClasses) {
    for (let name in contentClasses) {
      this.registerClass(name, contentClasses[name]);
    }
  }

  registeredClasses () {
    return Array.from(this._registry.entries());
  }

  // Sneak a class registration in that isn't actually meant to be
  // accessed by application code - e.g. Route definitions etc.
  implicitlyRegister (name, contentClass) {

    if (this.hasClassNamed(name)) {
      let existing = this.loadClassNamed(name);
      if (existing !== contentClass) {
        throw new Error(`Can't implicitly register ${name} because it is already registered by ${existing}`);
      }
    }
    this.registerClass(name, contentClass, true);
  }
}


export default function registry(contentClasses) {
  return new ContentRegistry(contentClasses);
}



// WEBPACK FOOTER //
// ./lib/rlink-repos/registry.js